.icon-constellation {
  &__top-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__inner-container {
      width: 300px;
      display: flex;
      justify-content: space-between;
    }
  }

  &__icon {
    &-left {
      position: relative;
      height: auto !important;
      width: 75px !important;
      margin-top: 50px;
    }

    &-top {
      position: relative;
      height: auto !important;
      width: 75px !important;
      margin-bottom: 60px;
    }

    &-right {
      position: relative;
      height: auto !important;
      width: 75px !important;
      margin-top: 60px;
    }

    &-center {
      position: relative;
      height: auto !important;
      width: 200px !important;
    }
  }
}
